export interface AppPreference {
  emailNotifications: boolean;
  payrollReleases: boolean;
  announcements: boolean;
  compactMode: boolean;
  collapseSidebarByDefault: boolean;
}

export const DEFAULT_APP_PREFERENCE: AppPreference = {
  emailNotifications: true,
  payrollReleases: true,
  announcements: true,
  compactMode: false,
  collapseSidebarByDefault: false,
};

export interface EmployeeSettings {
  locale: string;
  timezone: string;
  dateFormat: string;
  timeFormat: '12h' | '24h';
  weekStartsOn: 'sunday' | 'monday';
  defaultLandingPage: '/me/dashboard' | '/me/dtr' | '/me/leaves' | '/me/payslips' | '/me/overtime';
  emailNotifications: boolean;
  leaveNotifications: boolean;
  overtimeNotifications: boolean;
  payrollNotifications: boolean;
  announcementNotifications: boolean;
  compactMode: boolean;
  collapseSidebarByDefault: boolean;
  showEmailToCoworkers: boolean;
  showBirthdayOnDirectory: boolean;
}

export const DEFAULT_EMPLOYEE_SETTINGS: EmployeeSettings = {
  locale: 'en-PH',
  timezone: 'Asia/Manila',
  dateFormat: 'MMM d, y',
  timeFormat: '12h',
  weekStartsOn: 'monday',
  defaultLandingPage: '/me/dashboard',
  emailNotifications: true,
  leaveNotifications: true,
  overtimeNotifications: true,
  payrollNotifications: true,
  announcementNotifications: true,
  compactMode: false,
  collapseSidebarByDefault: false,
  showEmailToCoworkers: true,
  showBirthdayOnDirectory: false,
};
